import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=127f687e&"
import script from "./Models.vue?vue&type=script&lang=ts&"
export * from "./Models.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports